import React, { useEffect } from "react";

function Header() {
    // ============= LIGHTBOX =============
    useEffect(() => {
        const overlay = document.getElementById("lightbox1");
        const closeBtn = document.getElementById("lightbox1-close");
        const dataBox = document.getElementById("lightbox1-data");

        const thumbs = document.querySelectorAll(".thumb1");
        let currentIndex = 0;

        function openLightbox2() {

            window.history.pushState({ lightbox1: true }, "", window.location.href);
            openFullscreen(overlay);
            // Put company slider inside
            const content = document.querySelector("#lightbox1-items .modal-content").innerHTML;
            dataBox.innerHTML = content;

            overlay.style.display = "flex";
            setTimeout(() => overlay.classList.add("show"), 10);

            initCompanySlider(); // initialize slider after injection
        }


        function openFullscreen(elem) {
            if (!document.fullscreenElement) {
                elem.requestFullscreen?.().catch(() => { });
            }
        }

        function closeLightbox2() {
            closeFullscreen2();

            overlay.classList.remove("show");
            setTimeout(() => (overlay.style.display = "none"), 300);
        }

        function closeFullscreen2() {
            if (document.fullscreenElement) {
                document.exitFullscreen?.().catch(() => { });
            }
        }

        closeBtn.addEventListener("click", closeLightbox2);

        thumbs.forEach(btn => {
            btn.addEventListener("click", () => {
                openLightbox2();
            });
        });

        // KEYBOARD
        document.addEventListener("keydown", (e) => {
            // alert(e.key);
            if (overlay.style.display !== "flex") return;

            if (e.key === "Escape") {
                closeLightbox2();
            }
            // F11 → close fullscreen + close popup
            if (e.key === "F11") {
                closeLightbox2();
            }
        });

        // BACK BUTTON
        window.addEventListener("popstate", () => {
            if (overlay.style.display === "flex") {
                closeLightbox2();
            }
        });

        function onFullscreenChange() {
            // If fullscreen exited, close popup automatically
            if (!document.fullscreenElement) {
                closeLightbox2();
            }
        }
        document.addEventListener("fullscreenchange", onFullscreenChange);

    }, []);

    // ============= SLIDER INIT =============
    function initCompanySlider() {
        const container = document.querySelector("#companySlider");
        if (!container) return;

        const slides = container.querySelectorAll(".slide");
        let current = 0;
        const total = slides.length;

        // remove old arrows (avoid double creation)
        const oldArrows = container.querySelectorAll(".arrow");
        oldArrows.forEach(a => a.remove());

        slides.forEach((slide, i) => {
            slide.querySelector(".slide-number").textContent = `${i + 1} / ${total}`;
        });

        // CREATE ARROWS
        const prevBtn = document.createElement("button");
        prevBtn.className = "arrow prev";
        prevBtn.innerHTML = "<span class='material-symbols-outlined'>arrow_back_ios</span>";

        const nextBtn = document.createElement("button");
        nextBtn.className = "arrow next";
        nextBtn.innerHTML = "<span class='material-symbols-outlined'>arrow_forward_ios</span>";

        container.appendChild(prevBtn);
        container.appendChild(nextBtn);


        function updateArrows() {
            prevBtn.style.opacity = current === 0 ? "0" : "1";
            nextBtn.style.opacity = current === total - 1 ? "0" : "1";

            prevBtn.style.pointerEvents = current === 0 ? "none" : "auto";
            nextBtn.style.pointerEvents = current === total - 1 ? "none" : "auto";
        }

        updateArrows();

        function changeSlide(dir) {
            slides[current].classList.remove("active");

            let nextIndex = current + dir;

            if (nextIndex < 0) nextIndex = 0;
            if (nextIndex >= total) nextIndex = total - 1;

            current = nextIndex;
            slides[current].classList.add("active");
            updateArrows();
        }

        prevBtn.addEventListener("click", () => changeSlide(-1));
        nextBtn.addEventListener("click", () => changeSlide(1));

        // DRAG / SWIPE
        let startX = 0;
        let isDown = false;

        const startDrag = x => {
            isDown = true;
            startX = x;
        };

        const endDrag = x => {
            if (!isDown) return;
            const diff = x - startX;

            if (Math.abs(diff) > 50) {
                diff < 0 ? changeSlide(1) : changeSlide(-1);
            }
            isDown = false;
        };

        container.addEventListener("mousedown", e => startDrag(e.clientX));
        container.addEventListener("mouseup", e => endDrag(e.clientX));
        container.addEventListener("mouseleave", () => (isDown = false));

        container.addEventListener("touchstart", e => startDrag(e.touches[0].clientX));
        container.addEventListener("touchend", e => endDrag(e.changedTouches[0].clientX));

        // KEYBOARD LEFT / RIGHT SUPPORT
        document.addEventListener("keydown", (e) => {
            if (document.getElementById("lightbox1").style.display !== "flex") return;

            if (e.key === "ArrowRight") changeSlide(1);
            if (e.key === "ArrowLeft") changeSlide(-1);
        });


    }

    return (
        <>
            <div className="herobanner">
                <nav className="topbar">
                    <div className="container">
                        <a className="logo" href="https://otpl.co.in">
                            <img src="https://test.onwork.co.in/mis/public/rr/images/logo.png" alt="logo" />
                        </a >
                    </div>
                </nav>

                <header className="hero">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <h1 className="display-6 mb-2">Our Successful Projects</h1>
                                <p className="lead">
                                    Showcasing platforms built for government, education, and enterprises-empowering governance, efficiency, and growth.
                                </p>

                                <span className="profile-btn thumb1">
                                    <div className="color"></div>
                                    <span>Company Profile</span>
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </header>
            </div>

            {/* LIGHTBOX */}
            <div className="lightbox-overlay" id="lightbox1">
                <div className="lightbox-content" style={{ width: "115%" }}>
                    <button className="lightbox-close" id="lightbox1-close">
                        &times;
                    </button>
                    <div className="lightbox-body" id="lightbox-body">
                        <div className="lightbox-data" id="lightbox1-data"></div>
                    </div>
                </div>
            </div>

            {/* HIDDEN ORIGINAL CONTENT */}

            <div id="lightbox1-items" className="d-none">
                <div className="modal-content">



                    <div className="slideshow-container slideshow-container2" id="companySlider">
                        <div className="slide slide-1 active">
                            <div className="row">
                                <div className="col-md-5 pfcover">
                                    <div className="bigcirclie">
                                        <div className="incirclie"></div>
                                    </div>
                                </div>
                                <div className="col-md-7 position-relative coverlightbg">
                                    <div className="coverimg"><img src="https://test.onwork.co.in/mis/public/rr/images/pfcover.jpg" /></div>
                                    <div className="pfcontent">
                                        <h1>OMNINET TECHNOLOGIES</h1>
                                        <p className="subtitle">Delivering web-based solutions since 1996</p>
                                        <div className="tagline">Trust Us... We Trust Technology</div>
                                        <div className="slide-number"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="slide slide-2">
                            <div className="row">
                                <div className="col-md-6">
                                    <h2>WHY CHOOSE US?</h2>
                                    <ul className="speciality">
                                        <li>
                                            <div className="c-num"> <span>30+</span> Years of Experience </div>
                                        </li>
                                        <li>
                                            <div className="c-num"> <span>850+</span> Satisfied Clients </div>
                                        </li>
                                        <li>
                                            <div className="c-num"> <span>1200+</span> Government Portals Developed </div>
                                        </li>
                                        <li>
                                            <div className="c-num"> <span>300+</span> Team of Technical Professionals </div>
                                        </li>
                                        <li>
                                            <div className="c-num"> <span>4800+</span> Projects Delivered Successfully </div>
                                        </li>
                                        <li>
                                            <div className="c-num"> <span>1 Crore+</span> Students Database Management </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-6 pl50">
                                    <div className="datadiv mb-5 mt-5"> <img src="https://test.onwork.co.in/mis/public/rr/images/OTPL_Company_Profile_Custom.jpg" />
                                        <h2>MISSION</h2>
                                        <p>To be client-centric, technology-driven, adaptive, innovative and creative in our approach for achieving absolute excellence and promoting profitability for our clients and for ourselves by delivering the best IT solutions.</p>
                                    </div>
                                    <div className="datadiv"> <img src="https://test.onwork.co.in/mis/public/rr/images/OTPL_Company_vision.jpg" />
                                        <h2>VISION</h2>
                                        <p>To be admired as an organization with integrity, honesty, ethical in its conduct, professional in its approach, well-dedicated, cost-effective, and to provide world-class solutions that satisfy the needs of our customers.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-3">
                            <h2>Our Services</h2>
                            <ul className="services_1">
                                <li><img src="https://test.onwork.co.in/mis/public/rr/images/web_dev.gif" /> <span>Website Design & Development</span> </li>
                                <li><img src="https://test.onwork.co.in/mis/public/rr/images/smartphone-coding.gif" /> <span>Software & Mobile-App Development</span> </li>
                                <li><img src="https://test.onwork.co.in/mis/public/rr/images/social-media.gif" /> <span>Social & Digital Media</span> </li>
                                <li><img src="https://test.onwork.co.in/mis/public/rr/images/cloud-computing.gif" /> <span>Cloud Services</span> </li>
                                <li><img src="https://test.onwork.co.in/mis/public/rr/images/online-lesson.gif" /> <span>Online Examination (CBT/Proctored)</span> </li>
                                <li><img src="https://test.onwork.co.in/mis/public/rr/images/personal-data.gif" /> <span>Cyber Security</span> </li>
                                <li><img src="https://test.onwork.co.in/mis/public/rr/images/consultation.gif" /> <span>IT Consultancy Services</span> </li>
                                <li><img src="https://test.onwork.co.in/mis/public/rr/images/social-media.gif" /> <span>Digitization</span> </li>
                                <li><img src="https://test.onwork.co.in/mis/public/rr/images/online-lesson_1.gif" /> <span>E-Learning</span> </li>
                                <li><img src="https://test.onwork.co.in/mis/public/rr/images/digital-native_1.gif" /> <span>Digital Evaluation</span> </li>
                            </ul>
                            <div className="slide-number"></div>
                        </div>
                        <div class="slide slide-4">
                            <h2>Our Certifications & Associations </h2>
                            <div class="row g-4 mt-3">
                                <div class="col-md-3 col-6" data-aos="zoom-in" data-aos-delay="500">
                                    <div class="cert-card"> <img src="https://test.onwork.co.in/mis/public/rr/images/ITI.jpg" alt="ITI Limited" class="logo" />
                                        <h6>ITI Limited</h6>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6" data-aos="zoom-in" data-aos-delay="600">
                                    <div class="cert-card"> <img src="https://test.onwork.co.in/mis/public/rr/images/cel.jpg" alt="NSIC" class="logo" />
                                        <h6>Central Electronics Limited (CEL)</h6>
                                    </div>
                                </div>

                                <div class="col-md-3 col-6" data-aos="zoom-in" data-aos-delay="300">
                                    <div class="cert-card"> <img src="https://test.onwork.co.in/mis/public/rr/images/updesco.jpg" alt="UPDESCO" class="logo" />
                                        <h6>Uttar Pradesh Development Systems Corporation Ltd. (UPDESCO)</h6>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6" data-aos="zoom-in" data-aos-delay="400">
                                    <div class="cert-card"> <img src="https://test.onwork.co.in/mis/public/rr/images/uplc.jpg" alt="UPLC" class="logo" />
                                        <h6>Uttar Pradesh Electronics Corporation Limited. (UPLC)</h6>
                                    </div>
                                </div>

                                <div class="col-md-3 col-6" data-aos="zoom-in" data-aos-delay="700">
                                    <div class="cert-card"> <img src="https://test.onwork.co.in/mis/public/rr/images/gigw.jpg" alt="GIGW" class="logo" />
                                        <h6>Guidelines for Indian Government Websites</h6>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6" data-aos="zoom-in" data-aos-delay="100">
                                    <div class="cert-card"> <img src="https://test.onwork.co.in/mis/public/rr/images/cmmi.jpg" alt="CMMI" class="logo" />
                                        <h6>CMMI Level 5</h6>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6" data-aos="zoom-in" data-aos-delay="200">
                                    <div class="cert-card iso"> <img src="https://test.onwork.co.in/mis/public/rr/images/iso.jpg" alt="ISO" class="logo" />
                                        <h6>9001:2015<br />
                                            27001:2013<br />
                                            20000-1:2018<br />
                                            20000-11:2021</h6>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6" data-aos="zoom-in" data-aos-delay="800">
                                    <div class="cert-card"> <img src="https://test.onwork.co.in/mis/public/rr/images/superai.jpg" alt="Super AI Polaris" class="logo" />
                                        <h6>Super AI Polaris Pvt. Ltd.</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="slide-number"></div>
                        </div>
                        <div className="slide slide-5">
                            <h2>Awards and Accolades </h2>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="stqcimg"><img src="https://test.onwork.co.in/mis/public/rr/images/stqc_certificate.jpg" alt="" /></div>
                                </div>
                                <div className="col-md-7 pl50"> <img src="https://test.onwork.co.in/mis/public/rr/images/stqc_logo.png" style={{ 'height': '100px', 'float': 'left', 'margin-right': '20px', 'margin-top': '56px' }} />
                                    <h3 className="awardtitle"><span>1st</span> Company to get <span>STQC Certification</span> for GIGW Websites of Uttar Pradesh Government. </h3>
                                    <p className="fw-bold">First to achieve 15 STQC Certificates for GIGW-compliant websites developed for various Government Departments of Uttar Pradesh.</p>

                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-5">
                            <h2>Awards and Accolades </h2>
                            <div className="row">
                                <div className="col-md-8">
                                    <h3 className="awardtitle">Championing Accessibility </h3>
                                    <p className="fw-bold">Honored with the National Award for integrating best-in-class accessibility features for Persons with Disabilities in the official website of the Department of Empowerment of Persons with Disabilities, Uttar Pradesh.</p>
                                    <ul className="gigwicons">
                                        <li><span><img src="https://test.onwork.co.in/mis/public/rr/images/gigwicon/devices.png" /></span> Mobile Responsive</li>
                                        <li><span><img src="https://test.onwork.co.in/mis/public/rr/images/gigwicon/screen-reader.png" /></span> Screen Reader Access</li>
                                        <li><span><img src="https://test.onwork.co.in/mis/public/rr/images/gigwicon/increase-text.png" /></span> Font Increase</li>
                                        <li><span><img src="https://test.onwork.co.in/mis/public/rr/images/gigwicon/decrease-text.png" /></span> Font Decrease</li>
                                        <li><span><img src="https://test.onwork.co.in/mis/public/rr/images/gigwicon/color-theme.png" /></span> Contrast Theme</li>
                                        <li><span><img src="https://test.onwork.co.in/mis/public/rr/images/gigwicon/leterspace.png" /></span> Letter Spacing</li>
                                        <li><span><img src="https://test.onwork.co.in/mis/public/rr/images/gigwicon/lineheightincrease.png" /></span> Line Height</li>
                                    </ul>
                                </div>
                                <div className="col-md-3"><img src="https://test.onwork.co.in/mis/public/rr/images/certificate.jpg" className="img-fluid" /></div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-5 eletswards">
                            <h2>Awards and Accolades </h2>
                            <div className="row">
                                <div className="col-md-9">
                                    <h3 className="awardtitle">Elets Innovation Award 2022 </h3>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/digilogo.png" style={{ 'height': '70px', 'float': 'right', 'margin-left': '15px' }} />
                                    <p>Recognized at the <strong>AtmaNirbhar Bharat Summit</strong>, where the Department of IT & Electronics, GoUP, received this prestigious award for the <strong>DigiShakti Web Portal</strong>, designed and developed by Omninet.</p>
                                    <h5 className="mt-5 mb-3"><strong>Digishakti web portal has been developed to distribute tablet PCs and smartphones to the youth studying in institutions of Uttar Pradesh.</strong></h5>
                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="digishakti_detail">
                                                <div className="img"><img src="https://test.onwork.co.in/mis/public/rr/images/distribute.jpg" /></div>
                                                <div className="details"><span>50 lakh+</span> Youth have received Tablet PCs & Smartphone </div>
                                            </div>
                                        </div>
                                        <div className="col-md-7">
                                            <div className="digishakti_detail">
                                                <div className="img"><img src="https://test.onwork.co.in/mis/public/rr/images/distribute_2.jpg" /></div>
                                                <div className="details">
                                                    <ul>
                                                        <li><strong>1 Cr+</strong> Students </li>
                                                        <li><strong>25K</strong> Institutions </li>
                                                        <li><strong>30+</strong> UBSC</li>
                                                        <li><strong>15+</strong> Departments</li>
                                                        <li><strong>75</strong> Districts</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="awardname gold"> “SKOCH Gold Award”</div>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/skoch_gold.jpg" className="img-fluid" /> </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-5">
                            <h2>Awards and Accolades </h2>
                            <div className="row">
                                <div className="col-md-7">
                                    <h3 className="awardtitle"><img src="https://test.onwork.co.in/mis/public/rr/images/odishalogo.png" style={{ 'height': '70px', 'float': 'left', 'margin-right': '15px' }} />Electronic & Information Technology Department
                                        Government of <span>Odisha</span> </h3>
                                    <p>The Electronics and <strong>Information Department-Government of Odisha</strong> was felicitated with the <strong>Silver</strong> medal in E-Governance for <strong>Telecom Infrastructure Facilitation and Management System (TIFMS) at the Skoch Award 2022</strong> </p>
                                </div>
                                <div className="col-md-1"></div>
                                <div className="col-md-3">
                                    <div className="awardname mb-3 silver"> “SKOCH Silver Award”</div>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/skoch_silver.jpg" className="img-fluid" /></div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div class="slide slide-6">
                            <h2>Technology</h2>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="techbox">
                                        <h4>Web Frontend</h4>
                                        <ul class="techlogo">
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/angular.jpg" /> Angular</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/react.jpg" /> React</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/vue.jpg" /> Vue.js</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/svelte.jpg" /> Svelte</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="techbox">
                                        <h4>Mobile Development</h4>
                                        <ul class="techlogo">
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/android.jpg" /> Android</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/ios.jpg" /> iOS</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/flutter.jpg" /> Flutter</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/react.jpg" /> React Native</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="techbox">
                                        <h4>Backend Frameworks</h4>
                                        <ul class="techlogo">
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/dotnet.jpg" /> .Net</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/netcore.jpg" /> .Net Core</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/laravel.jpg" /> Laravel</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/nextjs.jpg" /> Next.js</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="techbox">
                                        <h4>CMS</h4>
                                        <ul class="techlogo">
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/wordpress.jpg" /> WordPress</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/dupel.jpg" /> Drupal</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/magento.jpg" /> Magento</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/shopify.jpg" /> Shopify</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="techbox">
                                        <h4>Database</h4>
                                        <ul class="techlogo">
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/sql_server.jpg" /> SQL Server</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/mysql.jpg" /> MySql</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/postgresql.jpg" /> PostgreSQL</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/mongodb.jpg" /> MongoDB</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="techbox">
                                        <h4>Languages/Runtimes</h4>
                                        <ul class="techlogo fourcolm">
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/java.jpg" /> Java</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/python.jpg" /> Python</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/php.jpg" /> PHP</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/dart.jpg" /> Dart</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/kotlin.jpg" /> Kotlin</li>
                                            <li><img src="https://test.onwork.co.in/mis/public/rr/images/techicon/nodejs.jpg" /> Node.js</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="slide-number"></div>
                        </div>

                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/cyberpolice.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">UP Police Cyber Crime Wing</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div> Website (GIGW Compliant) (cyberpolice.uppolice.gov.in) </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Director General Police, Shri Prashant Kumar</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>17th Jan., 2025</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Director General Police, Shri Prashant Kumar </li>
                                            <li>Shri Titus Varghese, Project Head, Omninet </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>

                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/gida.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Gorakhpur Industrial Development Authority</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div> GIDA Sewa Portal (gidagkp.in) </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Chief Minister Yogi Adityanath</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>30th November, 2024</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Nand Gopal Gupta 'Nandi‘ Cabinet Minister, Industrial Development Department, UP </li>
                                            <li>Shri Titus Varghese, Project Head, Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/updi.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Directorate of Industries, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Portal for Online Allotment of Vacant Lands/Sheds and other tasks</div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon'ble Chief Minister of UP, Shri Yogi Adityanath</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>13th March 2024</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Yogi Adityanath, Hon’ble Chief Minister, UP</li>
                                            <li>Shri Rajesh Kumar, Commissioner & Director, Directorate of Industries & Enterprise Promotion, UP</li>
                                            <li>Shri Rishi Ranjan Goel, Joint Commissioner Industries</li>
                                            <li>Shri Manoj Kumar, Joint Commissioner Industries</li>
                                            <li>Mrs. Sandhya Yadav, Deputy Commissioner Industries</li>
                                            <li>Shri Titus Varghese, Project Head, Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>

                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/gis.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Invest UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>UPGIS Event</div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon'ble Prime Minister, Shri Narendra Modi</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>10th to 12th Feb., 2023</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Hon’ble Governor of UP, Smt. Anandiben Patel</li>
                                            <li>Chief Minister Yogi Adityanath</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/inspectorate.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Inspectorate of Government Office, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Website (GIGW Compliant) (inspectorate.up.gov.in)</div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Principal Secretary, Administration Reforms & Public Service Mgmt. Dept., Shri K. Ravindra Nayak, (IAS)</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>13th Sept., 2023</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Shri K. Ravindra Nayak (IAS), Principal Secretary, Administration Reforms & Public Service Mgmt. Dept.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/sports.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Sports Directorate, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Khel Sathi Portal</div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon’ble Minister of State, Department of Sports & Youth Welfare, UP Shri Girish Chandra Yadav</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>11th July, 2023</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Shri Girish Chandra Yadav, Hon’ble Minister of State, Department of Sports & Youth Welfare, UP</li>
                                            <li>Shri Navneet Sehgal, (Retd. IAS), ACS, Department of Sports, UP</li>
                                            <li>Shri Suhas L.Y. (IAS), DG, Youth Welfare, UP</li>
                                            <li>Shri Kamal Shukla, Business Development Manager, Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>

                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/investup.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Invest UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div> Nivesh Sarathi Web Portal (Entrepreneur Relationship Management), UPGIS Website, B2B Meeting and Registration Portal </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Chief Minister Yogi Adityanath</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>22nd November, 2022</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Nand Gopal Gupta 'Nandi‘Cabinet Minister, Industrial Development Department, UP</li>
                                            <li>Jaswant Singh Saini</li>
                                            <li>Shri Durga Shankar Mishra, Chief Secretary, Uttar Pradesh</li>
                                            <li>Shri Arvind Kumar, IIDC, Additional Chief Secretary, Infrastructure & Industrial Development Department</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/bedup.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Basic Education Department, Uttar Pradesh</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div> Website (GIGW Compliant) (basiceducation.up.gov.in) </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon’ble Minister of State (Independent Charge) Shri Sandeep Singh</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>08th Aug., 2022</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Shri Vijay Kiran Anand, Director General, Basic Education Department, Uttar Pradesh</li>
                                            <li>Shri Pratap Singh Baghel, Secretary Council, Basic Education Department, Uttar Pradesh</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/uppc.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Uttar Pradesh Pharmacy Council</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div> Website (GIGW Compliant) (uppc.up.gov.in) </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>President of the Council Dr. Vedbrata Singh and Director General of Health Dr. Deepa Tyagi</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>28th Jan, 2022</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Dr. Vedbrata Singh, President of the Council</li>
                                            <li>Dr. Deepa Tyagi, Director General of Health</li>
                                            <li>Dr. Nirupama Dixit, Registrar, Uttar Pradesh Pharmacy Council</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>

                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/diid.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Department of Infrastructure and Industrial Development, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>
                                                        <ol>
                                                            <li>Web Portal for distribution of Tablets & Smartphones to approx. 1 crore Students Studying in the 16,000+ Educational Institutions & Other Targeted Beneficiaries of UP</li>
                                                            <li>Mapper Mobile App for mapping all the Tablet/ Smartphone devices with Students' Data and Adhyayan Mobile App to send notifications about the Academic and other information to the students</li>
                                                        </ol>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon’ble Chief Minister, UP</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>25th December 2021</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Yogi Adityanath, Hon’ble Chief Minister, UP</li>
                                            <li>Shri Dharmendra Pradhan, Minister of Education and Minister of Skill Development and Entrepreneurship, Government of India </li>
                                            <li>Shri Satish Mahana, Minister of Industrial Development, UP </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/gwd.jpg" className="img-fluid projectpic" /></div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Ground Water Department</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Web Portal for Application for Registration for Well, Application for Issuance of NOC for Well, Application for Registration of Drilling Agency and Online Grievance Redressal System </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon'ble Chief Minister of UP, Yogi Adityanath</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>31st January 2021</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Yogi Adityanath, Hon’ble Chief Minister, UP</li>
                                            <li>Dr. Mahendra Singh, Hon’ble Minister Jal Shakti, UP</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>

                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/nridept.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">NRI Department, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div> Unified Web Portal for NRIs </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon’ble Chief Minister of UP, Yogi Adityanath </div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>24th August 2020</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Yogi Adityanath, Hon’ble Chief Minister, UP</li>
                                            <li>Shri Satish Mahana, Minister Industrial & Infrastructural Development Department, UP</li>
                                            <li>Shri Siddharth Nath Singh, Minister NRI, UP</li>
                                            <li>Shri Rajendra Kumar Tiwari, Chief Secretary, UP</li>
                                            <li>Shri Alok Kumar, Additional Chief Secretary, UP</li>
                                            <li>Shri Ashish Srivastava, Director (Sales & Marketing), Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/rajbhawan.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Raj Bhavan, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>
                                                        <ol>
                                                            <li>Online Submission of Application for the Post of Vice Chancellor/Director for State Universities</li>
                                                            <li>Online Leave Management System for all the Vice Chancellors/ Directors of State Universities of UP</li>
                                                            <li>Redesigning of the Website (GIGW Compliant) (upgovernor.gov.in)</li>
                                                        </ol>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon’ble Governor of UP, Smt. Anandiben Patel </div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>11th Jan., 2020</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Smt. Anandiben Patel, Hon’ble Governor of UP</li>
                                            <li>Smt. Neelima Katiyar, Hon'ble State Minister, Higher Education UP</li>
                                            <li>Shri Hemant Rao, Addl Chief Secretary to the Governor UP</li>
                                            <li>Shri Ashok Chandra, Special Secretary to the Governor UP</li>
                                            <li>Shri Sudeep Banerjee, OSD (IT) to the Governor UP</li>
                                            <li>Shri Keyur C. Sampat, OSD (Education) to the Governor UP</li>
                                            <li>Vice Chancellors of various State Universities of UP</li>
                                            <li>Shri Titus Varghese, Project Head, Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/tourism.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Department of Tourism, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Web Portal to promote Religious Places of Varanasi. Information of approximately 108 significant temples has been brought on a single web platform (pawanpath.up.gov.in) by showcasing their Mythological stories, HD pictures, Videos, 360-degree images, and Virtual Tours.</div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon’ble Prime Minister, Shri Narendra Modi, India</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>30th November, 2020</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Shri Narendra Modi, Hon’ble Prime Minister, India</li>
                                            <li>Yogi Adityanath, Hon’ble Chief Minister, UP</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/udh.jpg" className="img-fluid projectpic" /></div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Urban Development & Housing Department, Govt. of Bihar </h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Online Integrated Portal for Mobile Tower and Optical Fibre Application Process and Disposal System </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon’ble Chief Minister of Bihar, Shri Nitish Kumar </div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>19th September 2020 </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Shri Nitish Kumar, Hon’ble Chief Minister, Bihar</li>
                                            <li>Shri Sushil Modi, Dy. Chief Minister, Bihar</li>
                                            <li>Shri Suresh Sharma, Minister, Urban Development & Housing Department, Govt. of Bihar</li>
                                            <li>Shri Anand Kishore, Secretary, Urban Development & Housing Department, Govt. of Bihar</li>
                                            <li>Shri Kamal Shukla, BDE (IT Sales), Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/mwwd.jpg" className="img-fluid projectpic" /></div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Minority Welfare & Waqf Department, UP </h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Website (GIGW Compliant) (minoritywelfare.up.gov.in) </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon’ble Cabinet Minister Minority Welfare Waqf & Hajj Department, UP Shri Nand Gopal Gupta ‘Nandi’ </div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>18th Dec 2020 </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Shri Nand Gopal Gupta ‘Nandi’, Hon’ble Cabinet Minister Minority Welfare Waqf & Hajj Department, UP</li>
                                            <li>Shri Mohsin Raza, Hon’ble Minister of State Minority Welfare Waqf & Hajj Department, UP</li>
                                            <li>Shri Manishaditya, Business Development Executive, Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/upsrtc.jpg" className="img-fluid projectpic" /></div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">UP State Road Transport Corporation </h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Website (GIGW Compliant) (upsrtc.com) </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon’ble Transport Minister, Shri Ashok Kataria' </div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>15th July, 2020 </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Shri Ashok Kataria, Hon’ble Transport Minister</li>
                                            <li>Shri Rajesh Kumar Singh, Principal Secretary</li>
                                            <li>Shri . Iftikharuddin, Chairman</li>
                                            <li>Dr. Raj Shekhar, Managing Director</li>
                                            <li>Shri Radhey Shyam, Additional Managing Director</li>
                                            <li>Shri Anagh Mishra, General Manager (IT), UPSRTC</li>
                                            <li>Ms. Shuchi Kalra, Manager (IT), UPSRTC</li>
                                            <li>Shri Titus Varghese, Project Head, Omninet Technologies Pvt. Ltd., Lucknow</li>
                                            <li>Shri Nitin Mishra, Technical Project Coordinator, Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>

                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/uplc_1.jpg" className="img-fluid projectpic" /></div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">UP Electronics Corporation Ltd., Lucknow</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Right of Way (RoW) Portal for Establishment of Overground & Underground Telegraph Infrastructure in UP </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon'ble Deputy Chief Minister of UP, Dr. Dinesh Sharma</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>14th June 2019</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Shri Dinesh Sharma, Deputy Chief Minister, UP</li>
                                            <li>Shri Anup Chandra Pandey, Chief Secretary, UP</li>
                                            <li>Shri Amit Sharma, Advisor, TRAI</li>
                                            <li>Shri Titus Varghese, Project Head, Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/uppolice.jpg" className="img-fluid projectpic" /></div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">UP Police Department</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Web Based Budget Monitoring System Software Module</div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Director General of Police, UP, Shri O P Singh </div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>14th Nov., 2019</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Shri B P Jogdand, ADG, Police Head Quarter</li>
                                            <li>Shri Asim Arun, ADG Technical, Police Head Quarter</li>
                                            <li>Shri Navneet Sekera, IG Housing, Police Head Quarter</li>
                                            <li>Shri Ashish Srivastava, Omninet Technologies Pvt. Ltd.</li>
                                            <li>Shri Kamal Shukla, Omninet Technologies Pvt. Ltd.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/upted.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Technical Education Department & Directorate, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div> Website (GIGW Compliant) (upted.gov.in) </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon'ble Chief Minister of UP, Shri Yogi Adityanath </div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>17th Feb 2019</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Yogi Adityanath, Hon’ble Chief Minister, UP</li>
                                            <li>Shri Bhuvnesh Kumar, IAS, Principal Secretary, Technical Education</li>
                                            <li>Shri Ashutosh Tandon (Gopal Ji), Hon’ble Technical & Medical Education Minister, UP</li>
                                            <li>Shri Ashish Srivastava, Director (Sales & Marketing), Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>

                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/odop.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Department of MSME & Export Promotion, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Web Portal (odopup.in) of One District One Product (ODOP)</div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon'ble President of India, Shri Ram Nath Kovind</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>10th Aug 2018</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Shri Ram Nath Kovind, Hon’ble President of India</li>
                                            <li>Shri Ram Naik, Former Governor, UP</li>
                                            <li>Yogi Adityanath, Hon’ble Chief Minister of UP</li>
                                            <li>Shri Keshav Prasad Maurya, Deputy Chief Minister, UP</li>
                                            <li>Shri Anup Chandra Pandey, Chief Secretary, UP</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>

                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/uphed.jpg" className="img-fluid projectpic" /> </div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Department of Higher Education, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Website (GIGW Compliant) (uphed.gov.in)</div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon'ble Chief Minister of UP, Yogi Adityanath</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>05th Sep 2017</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Yogi Adityanath, Hon’ble Chief Minister, UP</li>
                                            <li>Dr. Dinesh Sharma, Deputy Chief Minister, UP</li>
                                            <li>Shri Sandeep Singh, State Education Minister</li>
                                            <li>Shri Ashish Srivastava, Director (Sales & Marketing), Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/dharmarth.jpg" className="img-fluid projectpic" /></div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Dharmarth Karya Vibhag, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Web Portal for e-Pooja, Online Donation, Senior Citizen Yatra, Subsidy for Pilgrims of Kailash Mansarovar and Sindhu Darshan Yatra </div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon'ble Chief Minister of UP, Yogi Adityanath</div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>13th June 2017</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Yogi Adityanath, Hon’ble Chief Minister, UP</li>
                                            <li>Shri Chaudhary Lakshmi Narayan, Minister, Dharmarth Karya</li>
                                            <li>Shri Ashish Srivastava, Director (Sales & Marketing), Omninet Technologies Pvt. Ltd., Lucknow</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                        <div className="slide slide-8">
                            <div className="row">
                                <div className="col-md-4 pfcover">
                                    <h2>Launching</h2>
                                    <img src="https://test.onwork.co.in/mis/public/rr/images/bte.jpg" className="img-fluid projectpic" /></div>
                                <div className="col-md-8 position-relative">
                                    <div className="pfcontent">
                                        <h3 className="awardtitle">Board of Technical Education, UP</h3>
                                        <div className="launching">
                                            <ul>
                                                <li>
                                                    <div><strong>Project Launched  :</strong></div>
                                                    <div>Mobile App & Web Application for Online Verification of Marksheets & Certificates</div>
                                                </li>
                                                <li>
                                                    <div><strong>Launched by  :</strong></div>
                                                    <div>Hon’ble Technical & Medical Education Minister, Shri Ashutosh Tandon </div>
                                                </li>
                                                <li>
                                                    <div><strong>Date of Launching :</strong></div>
                                                    <div>04th Oct 2017</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <ul className="list">
                                            <li>Shri Ashutosh Tandon, Hon’ble Technical & Medical Education Minister, UP </li>
                                            <li>Shri Bhuvnesh Kumar, Chairman/Secretary, Technical & Vocational Education, UP </li>
                                            <li>Shri Titus Varghese, Project Head, Omninet Technologies Pvt. Ltd., Lucknow </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-number"></div>
                        </div>
                    </div>


                </div>
            </div>
        </>
    );
}

export default Header;
